'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformPipeOperator = transformPipeOperator;

var _types = require('./types');

var _types2 = _interopRequireDefault(_types);

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transformPipeOperator(path) {
  var _path$node = path.node,
      left = _path$node.left,
      right = _path$node.right,
      reversed = _path$node.reversed;

  var loc = (0, _astLocUtils.getSurroundingLoc)([left, right]);
  if (!reversed) {
    return path.replaceWith((0, _astLocUtils.placeAtLoc)(_types2.default.callExpression(right, [left]), loc));
  } else {
    return path.replaceWith((0, _astLocUtils.placeAtLoc)(_types2.default.callExpression(left, [right]), loc));
  }
}